module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/viddsee-for-good-social-media-card-543afe3709291c5bd0fdfdd08009bb5d.jpg";